import LoginModule from './login'
import RegisterModule from './register'
import SessionModule from './session'

const module = {
  namespaced: true, // user
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    login: LoginModule,
    register: RegisterModule,
    session: SessionModule
  }
}

export default module
